export const SET_REQUIRED_FIELD_ERRORS = 'set-required-field-errors';

export default function setRequiredFieldErrors({ requiredFieldErrors }) {
  return {
    type: SET_REQUIRED_FIELD_ERRORS,
    payload: { requiredFieldErrors },
  };
}
